export const signalRConfig = {
    baseURL: process.env.REACT_APP_SERVICE_URL,
    baseHubUrl: `${process.env.REACT_APP_SERVICE_URL}/`,
    overrideConnection: process.env.REACT_APP_SIGNALR_CONNECTION
}